"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Selectable = _interopRequireDefault(require("@commerce-ui/core2/Selectable"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var __jsx = _react["default"].createElement;
var IconTick = function IconTick(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.67 7.673l-9.196 11.6-6.095-6.007.842-.855 5.144 5.07L18.73 6.926l.94.746z"
  }));
};
IconTick.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var ItemRow = function ItemRow(props) {
  var _props$font = props.font,
    font = _props$font === void 0 ? "body2" : _props$font,
    _props$bgColor = props.bgColor,
    bgColor = _props$bgColor === void 0 ? "white" : _props$bgColor,
    _props$bgColorSelecte = props.bgColorSelected,
    bgColorSelected = _props$bgColorSelecte === void 0 ? "neutral100" : _props$bgColorSelecte;
  return __jsx(_Selectable["default"], props, function (_ref) {
    var disabled = _ref.disabled,
      highlighted = _ref.highlighted,
      selected = _ref.selected,
      label = _ref.label,
      textTransform = _ref.textTransform;
    return __jsx(_Box["default"], {
      sx: {
        width: "100%",
        // minWidth: "250px",
        height: "44px",
        display: "flex",
        padding: "12px",
        alignItems: "center",
        // pointerEvents: "none",
        lineHeight: 1,
        font: font,
        bg: highlighted || selected ? bgColorSelected : bgColor,
        opacity: disabled ? 0.5 : 1,
        justifyContent: "space-between"
      }
    }, __jsx(_Box["default"], {
      sx: {
        textTransform: textTransform
      }
    }, label), selected && __jsx(_Box["default"], {
      sx: {
        svg: {
          display: "block"
        }
      }
    }, __jsx(IconTick, null)));
  });
};
var _default = ItemRow;
exports["default"] = _default;